<template>
  <div class="content-page-dashboard-index">
    <div class="header">
      <span class="title">{{ $store.state.initialInfo.displayName || "--" }}的工作台</span>
      <div class="actions">
        <el-select :disabled="stateDisabled" :value="state" @input="onStateInput">
          <el-option v-for="item in states" :key="item.value" :label="item.label" :value="item.value" :disabled="
              item.enabledValues.indexOf($store.state.callState) === -1
            "></el-option>
        </el-select>
        <div class="btn btn-normal" :class="{ disabled: !currentUserPhone }"
          @click="currentUserPhone && createOrder(1)">
          服务下单
        </div>
        <div class="btn btn-normal" :class="{ disabled: !currentUserPhone }"
          @click="currentUserPhone && createOrder(2)">
          订餐下单
        </div>
        <div class="btn btn-normal" :class="{ disabled: !currentUserPhone }"
          @click="currentUserPhone && createOrder(3)">
          养老机构下单
        </div>
        <div class="btn btn-normal" :class="{ disabled: !currentUserPhone }"
          @click="currentUserPhone && createOrder(4)">
          日间照料中心下单
        </div>
        <div class="btn btn-normal" :class="{ disabled: !currentUserPhone }">
          添加投诉
        </div>
        <div class="btn btn-110" @click="dial('110')" :class="{ disabled: !isReady }">
          <i></i>110
        </div>
        <div class="btn btn-120" @click="dial('120')" :class="{ disabled: !isReady }">
          <i></i>120
        </div>
      </div>
      <div class="sound">
        <span>音量</span>
        <i class="iconfont iconyinliang1"></i>
        <el-slider :disabled="!isReady" v-model="volume"></el-slider>
        <i class="iconfont iconvolume-up"></i>
      </div>
    </div>
    <div class="body">
      <div class="left">
        <div id="ccbar"></div>
      </div>
      <div class="right">
        <information :call-number="callNumber" :inout="inout" @personPhone="getOlderPhone" />
      </div>
      <el-dialog :visible.sync="showMobileDialog" center :show-close="false" width="500px">
        <el-form labelWidth="160px" labelPosition="left" size="mini">
          <el-form-item label="转接手机号码：">
            <el-input clearable v-model="mobileNumberStr"></el-input>
          </el-form-item>
          <el-button native-type="submit" center type="primary" @click.native="setMobileNumber()">确认</el-button>
          <el-button native-type="submit" center type="primary" plain @click.native="closeDialog">取消</el-button>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Information from "@/components/pages/dashboard/Information";
export default {
  components: { Information },
  data() {
    return {
      state: 3,
      states: [
        { label: "挂起", value: 12, enabledValues: [9, 10, "TALK"] },
        { label: "取消挂起", value: -12, enabledValues: [12, "HELD"] },
        { label: "小休", value: 2, enabledValues: [3, "IDLE"] },
        { label: "接听来电", value: 3, enabledValues: [2, "BUSY"] },
        { label: "手机接听", value: 41, enabledValues: [3, "IDLE"] },
        { label: "下线", value: 1, enabledValues: [2, 3, "IDLE", "BUSY"] },
        { label: "仅外呼", value: 40, enabledValues: [3, "IDLE"] },
      ],
      volume: 50,
      olderPhone: "",
      showMobileDialog: false,
      mobileNumberStr: "",
    };
  },
  computed: {
    stateDisabled() {
      if (callByAli) {
        return [3, 2, 12].indexOf(this.$store.state.callState) === -1;
      } else {
        console.log(this.$store.state.callState);
        return (
          ["IDLE", "BUSY", "HELD"].indexOf(this.$store.state.callState) === -1
        );
      }
    },
    isReady() {
      if (callByAli) {
        return this.$store.state.callState > 2;
      } else {
        return (
          this.$store.state.callState != null &&
          this.$store.state.callState != "LOGOFF"
        );
      }
    },
    callNumber() {
      console.log(
        "callNumber----" + JSON.stringify(this.$store.state.callInfo)
      );
      if (this.$store.state.callInfo.inout === "in") {
        return this.$store.state.callInfo.caller;
      } else if (this.$store.state.callInfo.inout === "out") {
        return this.$store.state.callInfo.callee;
      } else return null;
    },
    inout() {
      return this.$store.state.callInfo.inout;
    },
  },
  mounted() {
    if (this.$store.state.want2call) {
      console.log("want2call:" + this.$store.state.want2call);
      if (callByAli && this.$store.state.callState == 3) {
        window.workbench.call(this.$store.state.want2call, "");
        this.$store.commit("setWant2call", "");
      } else if (!callByAli && this.$store.state.callState == "IDLE") {
        CallControl.workMode("outbound", function (result) {
          console.log(result);
        }); // inbound呼入,outbound呼出
        ccbarsdk.makecall(this.$store.state.want2call, "", function (res) {}); // 被叫号码,外显号码,通过CallControl.callerList获取或填""自动取技能组配置的号码
        this.$store.commit("setWant2call", "");
      }
    }
    this.$store.dispatch("initWorkbench");
  },
  watch: {
    "$store.state.callState"(val) {
      if (val === 3) {
        this.state = 3;
        if (this.$store.state.want2call) {
          window.workbench.call(this.$store.state.want2call, "");
          this.$store.commit("setWant2call", "");
        }
      } else if (val === "IDLE") {
        if (this.$store.state.want2call) {
          CallControl.workMode("outbound", function (result) {
            console.log(result);
          }); // inbound呼入,outbound呼出
          ccbarsdk.makecall(this.$store.state.want2call, "", function (res) {}); // 被叫号码,外显号码,通过CallControl.callerList获取或填""自动取技能组配置的号码
          this.$store.commit("setWant2call", "");
        }
      } else if ((oldVal == 3 && (val == 8 || val == 6)) || oldVal == "IDLE") {
        console.log("$store.state.callState", val, oldVal);
        this.setCallStatus();
      }
    },
    "$store.state.callInfo"(val) {
      if (val.inout) {
      } else {
      }
    },
    volume(val) {
      window.workbench.changeVolumeInCall(val / 100);
    },
  },
  methods: {
    getOlderPhone(val) {
      this.olderPhone = val;
    },
    onStateInput(val) {
      try {
        switch (val) {
          case 12:
            if (window.callByAli) {
              window.workbench.callHold();
            } else {
              CallControl.holdCall();
            }
            break;
          case -12:
            if (window.callByAli) {
              window.workbench.callRetrieve();
            } else {
              CallControl.unholdCall();
            }
            break;
          case 2:
            if (window.callByAli) {
              window.workbench.applyForBreak(5, "临时有事");
            } else {
              CallControl.agentNotReady();
            }
            break;
          case 41:
            this.showMobileDialog = true;
            break;
          case 40:
            if (callByAli) {
              window.workbench.applyForCallOnly(true);
            } else {
              CallControl.workMode("outbound", function (result) {
                console.log(result);
              });
            }
            break;
          case 3:
            if (callByAli) {
              window.workbench.ready();
            } else {
              CallControl.agentReady();
            }
            break;
          case 1:
            if (callByAli) {
              window.workbench.logOut();
            } else {
              CallControl.logoff(function (result) {
                try {
                  if (result.state != "1") {
                    tipsMsg(result.msg);
                  }
                } catch (e) {}
              });
            }
            break;
        }
        this.state = val;
      } catch (e) {}
    },
    dial(num) {
      if (callByAli) {
        window.workbench.call(num);
      } else {
        ccbarsdk.makecall(num, ""); // 外呼 被叫号码和外显号码,外显号码通过CallControl.callerList获取,如caller传''则外呼时自动取坐席对应的外显号码
      }
    },
    setMobileNumber() {
      if (!this.mobileNumberStr) {
        this.$message.error("手机号不能为空");
      } else if (!/^1[123456789]\d{9}$/.test(this.mobileNumberStr)) {
        this.$message.error("请输入正确的手机号");
      } else {
        window.workbench.offline(this.mobileNumberStr);
        this.showMobileDialog = false;
      }
    },
    closeDialog() {
      this.state = 3;
      this.showMobileDialog = false;
    },
  },
};
</script>
